import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchReminderListPageLoadResult,
  BatchReminderListPageLoadResultFromJSON
} from '@/api/models/batch/BatchReminderListPageLoadResult'
import {
  BatchReminderListRequest,
  BatchReminderListRequestToJSON
} from '@/api/models/batch/BatchReminderListRequest'

export class BatchReminderListApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReminderListPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReminderListPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createReminderList(request: BatchReminderListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reminder/list`,
      BatchReminderListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
